  /*============Vehicle Tagging Controller
  ================================*/
  angular
  		.module('vppApp')
  		.controller('vehicleDetailController', vehicleDetailController);

  		vehicleDetailController.$inject = ['$rootScope', '$scope', '$http', '$state', 'apiFactory', '$stateParams', 'vppConfig', 'AuthenticationService', 'CustomerService', 'VehicleDetailService', '$timeout'];

  		function vehicleDetailController($rootScope, $scope, $http, $state, apiFactory, $stateParams, vppConfig, AuthenticationService, CustomerService, VehicleDetailService, $timeout){
        var accountID = AuthenticationService.getAuthenticatedID();
        var programID;
        $scope.isFromViewAuth = $stateParams.from === 'view-auth';
        $scope.searchLoaded = false;
        var vin = VehicleDetailService.getVehicleDetailVin();


        $scope.getVehicleDetails = function(){
          if(accountID && programID && vin){
            apiFactory.vtDetail(accountID, programID, vin).then(function(response) {
              $scope.vehicle = response.data.vehicle;
              $scope.vin = vin;
              $scope.vehicleDetails = response.data.vehicleDetails;
              $scope.vehicleDetails.vehicleOptionVOs = $scope.orderVehicleOptions(response.data.vehicleDetails);
              $scope.vehicleOptionsTotal = parseFloat($scope.vehicle.totalMSRP) - parseFloat($scope.vehicle.destinationCharge);

              // remove QRD4 pricing
              if($scope.vehicleDetails.pricingMatrixVOs){
                for(var prop in $scope.vehicleDetails.pricingMatrixVOs){
                  if($scope.vehicleDetails.pricingMatrixVOs[prop].name.toLowerCase() === 'qrd4') delete $scope.vehicleDetails.pricingMatrixVOs[prop];
                }
              }
            }, function errorCallback(response) {
              $scope.serverError = response.data.errors;
            });
          }
        }

        // sort vehicleOptionVOs
        // optionCode param is optional
        $scope.orderVehicleOptions = function(data, optionCode) {
          var jsonVehicleOptions = data.vehicleOptionVOs;

          var xmlVehicleDetails = $.parseXML($scope.vehicle.xmlData);
          var jsonVehicleDetails = $scope.xmlToJson(xmlVehicleDetails);
          var jsonVehicleDetailsEntries = jsonVehicleDetails.Map.Entry;
          var jsonVehicleDetailsEntriesLength = jsonVehicleDetailsEntries.length;

          // loop through XML data from $scope.vehicle object
          for (var i = 0; i < jsonVehicleDetailsEntriesLength; i++) {
            var entryKey = jsonVehicleDetailsEntries[i].attributes.key;
            // split value into arr. format is [optionCode, optionDescription, msrp]
            var entryArr = jsonVehicleDetailsEntries[i].attributes.value.split('|');

            // loop through vehicleOptionVOs, add key from XML if descriptions match.
            for (var j = 0; j < jsonVehicleOptions.length; j++) {
              if(!jsonVehicleOptions[j].hasOwnProperty('attributes')) {
                jsonVehicleOptions[j].attributes = {};
                // high value pushes to the bottom of the list
                jsonVehicleOptions[j].attributes.key = 'OptionItem999';
              }
              // if the codes and descriptions match, add the key to the jsonVehicleOptions object so we can sort later.
              if(jsonVehicleOptions[j].optionDescription == entryArr[1] && jsonVehicleOptions[j].optionCode == entryArr[0]) {
                // check for optional filter param, only add attribute key if option code for entry matches optional filter
                if(typeof optionCode != 'undefined') {
                  if(entryArr[0] == optionCode) {
                    jsonVehicleOptions[j].attributes.key = entryKey;
                  }
                } else {
                  jsonVehicleOptions[j].attributes.key = entryKey;
                }
              }
            }
          }
          // sort jsonVehicleOptions and return
          return jsonVehicleOptions.sort($scope.sortOptions);
        };

        // used by $scope.orderVehicleOptions()
        $scope.sortOptions = function(a, b) {
          var keyA = a.attributes.key;
          var keyB = b.attributes.key;
          var comparison = 0;

          if (keyA > keyB) {
            comparison = 1;
          } else if (keyA < keyB) {
            comparison = -1;
          }
          return comparison;
        }

        // used by $scope.orderVehicleOptions()
        $scope.xmlToJson = function(xml) {
          var obj = {};

          if (xml.nodeType == 1) { // element
            // do attributes
            if (xml.attributes.length > 0) {
            obj["attributes"] = {};
              for (var j = 0; j < xml.attributes.length; j++) {
                var attribute = xml.attributes.item(j);

                obj["attributes"][attribute.nodeName] = attribute.nodeValue;
              }
            }
          } else if (xml.nodeType == 3) { // text
            obj = xml.nodeValue;
          }

          // do children
          if (xml.hasChildNodes()) {
            for(var i = 0; i < xml.childNodes.length; i++) {
              var item = xml.childNodes.item(i);
              var nodeName = item.nodeName;
              if (typeof(obj[nodeName]) == "undefined") {
                obj[nodeName] = $scope.xmlToJson(item);
              } else {
                if (typeof(obj[nodeName].push) == "undefined") {
                  var old = obj[nodeName];
                  obj[nodeName] = [];
                  obj[nodeName].push(old);
                }
                obj[nodeName].push($scope.xmlToJson(item));
              }
            }
          }
          return obj;
        };

        $scope.tagVehicle = function(){
          var taggingInfo = {"vin": vin};
          taggingInfo["contactPhone1"] = document.getElementsByClassName('js-vehicle-tag-phone')[0].value;
          if(!taggingInfo["contactPhone1"]) {
            delete taggingInfo["contactPhone1"];
          } else {
            taggingInfo["contactPhone1"] = taggingInfo["contactPhone1"].replace(/[()-\s]/g, '');
          }

          taggingInfo["contactPhone2"] = document.getElementsByClassName('js-vehicle-tag-phone2')[0].value;
          if(!taggingInfo["contactPhone2"]){
            delete taggingInfo["contactPhone2"];
          } else {
            taggingInfo["contactPhone2"] = taggingInfo["contactPhone2"].replace(/[()-\s]/g, '');
          }

          // taggingInfo["secondaryPassword"] = document.getElementsByClassName('js-vehicle-tag-secondaryPassword')[0].value;
          // if(!taggingInfo["secondaryPassword"]) delete taggingInfo["secondaryPassword"];


          apiFactory.vtTag(accountID, programID, taggingInfo).then(function(response) {
            window.sessionStorage.setItem("tagID", response.data.tagID);
            $state.go('vehicle-tag-success');
          }, function errorCallback(response) {
            $scope.serverError = response.data.errors;
          });
        }

        $scope.checkTagHistory = function(){
          if(accountID && programID){
            apiFactory.vtHistory(accountID, programID).then(function(response) {
              var history = response.data.vehicleTagHistoryList;
              $scope.hasVehicleTag = false;

              for (var i = 0; i < history.length; i++) {
                if (history[i].status.toLowerCase() === 'tagged') {
                  window.sessionStorage.setItem("hasVehicleTag", true);
                  $scope.hasVehicleTag = true;
                }
              }

            }, function errorCallback(response) {
              $scope.serverError = response.data.errors;
            });
          }
        }

        $scope.tagSuccess = function(){
          $scope.date = Date();
          apiFactory.getProfileDetails(accountID).then(function(response){
            $scope.firstName = response.data.customerDetails.firstName;
            $scope.lastName = response.data.customerDetails.lastName;
          }, function errorCallback(response) {
            $scope.serverError = response.data.errors;
          });
        }

        $scope.emailTagSuccess = function(){
          $rootScope.emailSent = false;
          var tagID = window.sessionStorage.getItem('tagID');
          var senderEmail = document.getElementById('emailSender').value;
          var emailRecipient = document.getElementById('emailRecipient').value;
          var message = document.getElementById('message').value;
          var options = {
            "recipientEmail": emailRecipient,
            "senderEmail": senderEmail,
            "message": message
          }

          apiFactory.vtSendEmail(accountID, tagID, options).then(function(response) {
            $scope.toggleModal();
            $scope.toggleModal('emailSentConfirmation');
          }, function errorCallback(response) {
            $scope.serverError = response.data.errors;
          });
        }

        $scope.passPopUpTitle = function (title) {
          $scope.popUpConfirmationTitle = title;
        }

        $scope.goBackVehicleSearch = function(){
          $scope.searchLoaded = false;
        }

        var onCustomerLoaded = function(customer) {
          if (customer) {
            var programIds = CustomerService.getProgramIDs();
            for(var i = 0; i < programIds.length; i++){
              if(programIds[i].code.toLowerCase() === 'vts'){
                programID = programIds[i].programID;
              }
            }
            $scope.checkTagHistory();
            $scope.getVehicleDetails();
          }
        };

        CustomerService.addObserver(onCustomerLoaded);

        $scope.$on("$destroy", function() {
          CustomerService.removeObserver(onCustomerLoaded);
        });

  		}